// material ui
import { alpha, Theme } from '@mui/material';

export const menuCustomization = {
  MuiMenu: {
    defaultProps: {
      elevation: 0,
      anchorOrigin: {
        vertical: 'bottom' as const,
        horizontal: 'right' as const,
      },
      transformOrigin: {
        vertical: 'top' as const,
        horizontal: 'right' as const,
      },
    },
    styleOverrides: {
      paper: ({ theme }: { theme: Theme }) => ({
        borderRadius: '6px',
        minWidth: 220,
        border: '1px solid',
        borderColor: theme.palette.divider,
        color:
          theme.palette.mode === 'dark'
            ? theme.palette.grey[300]
            : 'rgb(55, 65, 81)',
        boxShadow:
          'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
      }),
      list: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  },
  MuiMenuList: {
    styleOverrides: {
      root: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        margin: theme.spacing(0.5),
        borderRadius: theme.shape.borderRadius,
        '&.Mui-selected': {
          backgroundColor: theme.palette.action.selected,
          '&:hover': {
            backgroundColor: theme.palette.action.selected,
          },
        },
        '&:active': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity,
          ),
        },
      }),
    },
  },
};
